import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) { }

  public employee(employeeId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/employees/${employeeId}`);
  }

  public partner(referralCode: string, data: {}): Observable<any> {
    return this.httpClient.post(`${environment.master_url}/api/customer/public/partners/${referralCode}`, data);
  }

  public suitable(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/employees`, data);
  }
}
